const Env = {
  prod: 'http://mobile.jiahuiku.cn', //正式环境
  mobileUrlFormal: 'http://mobile.jiahuiku.cn', // 正式环境H5的Url
  mobileUrlList: ['mobile.lnvs.cn', 'mobile.jiahuiku.cn'], // 其他H5的Url
  mobileDnsList: ['lnvs.cn', 'jiahuiku.cn'], // 其他H5的Url
  ossFileUrl: 'http://zhilvchuxing.oss-cn-shenzhen.aliyuncs.com' // OSS 图片资源文件
}
export default Env
